import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';
import {
  migrateReportIsV3Published,
  migrateReportV3Access,
} from '../../screens/Settings/Advanced/V3Migrators/ContentV3AccessMigrator/utils';

const REPORTS_DOC = 'reports';
const CURRENT_REPORTS_VERSION = 'v2';

const reportConverter = {
  toFirestore(report: ReportType): firebase.firestore.DocumentData {
    return withoutNulls(report);
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<ReportType>,
    options: firebase.firestore.SnapshotOptions,
  ): ReportType {
    const data = snapshot.data(options);

    const report: ReportType = {
      ...data,
      isV3Published:
        data.isV3Published !== undefined
          ? data.isV3Published
          : migrateReportIsV3Published(data),
      v3Access: (data.v3Access = data.v3Access
        ? data.v3Access
        : migrateReportV3Access(data)),
      labelIds: data.labelIds || [],
    };

    return report;
  },
};

const getReportsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.CONTENT_DISTRIBUTIONS_COLLECTION)
    .doc(REPORTS_DOC)
    .collection(CURRENT_REPORTS_VERSION)
    .withConverter(reportConverter);
};

export default getReportsRef;
